// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__VDa+f","teacherInfo":"Dashboard_teacherInfo__pi7Hd","features":"Dashboard_features__NYsSO","feedbackContainer":"Dashboard_feedbackContainer__Q1xpW"};